export default option => {
    const { trade_no, id, amount, order_no, isSelect } = option;
    let payWaitUrl = `${window.BasePath}fund/activity/onepoint/paySuccess?trade_no=${trade_no}&id=${id}&amount=${amount}&order_no=${order_no}`;
    return payWaitUrl;
}